import {JourneyType, JourneyTypeSchema} from '@/types/JourneyType'
import {useIntl} from 'react-intl'
import {Link, useLocation} from 'react-router-dom'
import {ROUTES} from '../../../config/constants'

export const JourneyNameCell = ({name, id}: {name: string; id: string}) => {
  const location = useLocation()
  return (
    <div data-testid="name-cell" data-cy="name-cell">
      <Link
        to={ROUTES.EDIT_JOURNEY.replace(':id', id)}
        state={{prevPath: location.pathname + location.search}}
        className="font-inter text-sm text-link no-underline hover:text-link-hover"
        data-cy={`journey-item-${id}`}
        title="Edit Journey"
      >
        {name}
      </Link>
    </div>
  )
}

export const JourneyDescriptionCell = ({description}: {description: string}) => {
  return (
    <div data-testid="description-cell" className="journey-table-style">
      {description}
    </div>
  )
}

export const JourneyTypeCell = ({type = JourneyTypeSchema.enum.RECURRENT}: {type?: JourneyType}) => {
  const {formatMessage} = useIntl()

  return (
    <div data-testid="type-cell" className="journey-table-style">
      {formatMessage({id: `JOURNEY_BUILDER.JOURNEY_TYPE_${type}`})}
    </div>
  )
}

export const PublishedByCell = ({value}: {value?: string}) => {
  return (
    <div data-testid="published-by-cell" className="max-w-[300px] truncate text-sm" title={value}>
      {value || ''}
    </div>
  )
}
